import React, { useEffect } from "react";
import { Button, Card, Col, Container, Form, Row } from "react-bootstrap";
import { useMediaQuery } from "react-responsive";
import { Link } from "react-router-dom";
import { scrollToTop } from "../../helper/HelperFunctions";
const CustomerSignup = () => {
  const isDesktopOrLaptop = useMediaQuery({
    query: "(min-width: 1224px)",
  });
  useEffect(() => {
    scrollToTop();
  }, []);

  return (
    <section
      style={{
        backgroundColor: "#DDDDDD",
        height: "100vh",
        padding: isDesktopOrLaptop ? "10vh" : "3vh",
      }}
    >
      <Container>
        <Row style={{ height: "80vh", backgroundColor: "white" }}>
          <Col
            lg={6}
            md={6}
            sm={12}
            style={{
              textAlign: "center",
              padding: isDesktopOrLaptop ? 100 : 30,
            }}
          >
            <h1 className="poppins-bold">Signup</h1>
            <Form.Group className="mb-3 mt-5" controlId="formBasicEmail">
              <Form.Label
                style={{ width: "100%", textAlign: "left" }}
                className="poppins-bold"
              >
                Username
              </Form.Label>
              <Form.Control type="text" className="poppins-regular" />
            </Form.Group>
            <Form.Group className="mb-3 mt-3" controlId="formBasicEmail">
              <Form.Label
                style={{ width: "100%", textAlign: "left" }}
                className="poppins-bold"
              >
                Email
              </Form.Label>
              <Form.Control type="email" className="poppins-regular" />
            </Form.Group>
            <Form.Group className="mb-3 mt-3" controlId="formBasicEmail">
              <Form.Label
                style={{ width: "100%", textAlign: "left" }}
                className="poppins-bold"
              >
                Password
              </Form.Label>
              <Form.Control type="password" className="poppins-regular" />
            </Form.Group>
            <Button
              size="lg"
              variant="outline"
              className="poppins-bold green-outline-btn-lg px-2 py-1"
              onClick={() => {}}
            >
              Create Account
            </Button>
          </Col>
          <Col
            lg={6}
            md={6}
            sm={12}
            style={{
              backgroundColor: "green",
              textAlign: "center",
              padding: 100,
            }}
          >
            <h1 className="poppins-bold txt-white mt-5">Welcome Back</h1>
            <h5 className="poppins-bold txt-white mt-5">
              Welcome Back ! We are so happy to have you here. It's great to see
              you again. We wish you safe and enjoyable time ahead.
            </h5>

            <Link
              to="/customer-signin"
              size="lg"
              variant="outline"
              className="poppins-bold green-outline-btn-lg px-2 py-1 mt-5"
            >
              Already have an account ? Signin
            </Link>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default CustomerSignup;
